import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import './PublicNavbar.css';

export default function PublicNavbar() {
  return (
    <header className="public-navbar">
      <div className="public-navbar__inner">
        <Link to="/" className="public-navbar__brand">
          <BrandLogo size={32} />
          <span>Querely</span>
        </Link>
        <Link to="/login" className="public-navbar__cta">
          Log in
        </Link>
      </div>
    </header>
  );
}
